"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import { LANGUAGES } from "@crehana/ts-types";
import clsx from "clsx";
import { Loader } from "../../Loader/index.js";
const PageLoader = ({ size = 's', languageCode, className })=>{
    const { languageCode: translationLanguageCode } = useTranslation();
    const languageToUse = languageCode ?? translationLanguageCode ?? LANGUAGES.ES;
    const label = languageToUse === LANGUAGES.ES ? 'Cargando...' : 'Loading...';
    return /*#__PURE__*/ jsxs("div", {
        className: clsx('tw-w-full tw-mx-auto tw-h-screen tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-00', className),
        children: [
            /*#__PURE__*/ jsx(Loader, {
                size: size
            }),
            /*#__PURE__*/ jsx("span", {
                className: "tw-block tw-font-subtitle4 tw-mt-2 tw-text-neutral-light-700 dark:tw-text-neutral-dark-500",
                children: label
            })
        ]
    });
};
export { PageLoader };
